import { usePermissions, useRecordContext, useTranslate } from 'react-admin';
import CustomMorePopover from '@/components/global/buttons/CustomMorePopover.jsx';
import CustomShowModalButton from '@/components/global/buttons/CustomShowModalButton.jsx';
import CustomEditModalButton from '@/components/global/buttons/CustomEditModalButton.jsx';
import { useDrawer } from '@/composables/useDrawer';
import { canViewDetails } from '@/helpers/permissions/canViewDetails.js';

export const RetailChainMoreActions = () => {
    const record = useRecordContext();
    const translate = useTranslate();
    const { permissions } = usePermissions();
    const { openDrawer } = useDrawer();

    if (!record?.id || !canViewDetails('retail-chain', permissions)) {
        return null;
    }

    return (
        <CustomMorePopover record={record}>
            <CustomShowModalButton label={translate('resources.retailChain.labels.show')} onOpen={() => openDrawer(record.id, 'retail-chain-show')} />
            {permissions?.isAdmin ? (
                <CustomEditModalButton label={translate('resources.retailChain.labels.editChain')} onOpen={() => openDrawer(record.id, 'retail-chain-edit')} />
            ) : null}
        </CustomMorePopover>
    );
};

RetailChainMoreActions.propTypes = {};
